import { render } from "./BillingReport.vue?vue&type=template&id=af007754&scoped=true"
import script from "./BillingReport.vue?vue&type=script&lang=js"
export * from "./BillingReport.vue?vue&type=script&lang=js"

import "./BillingReport.vue?vue&type=style&index=0&id=af007754&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af007754"]])

export default __exports__